export { default as rules } from './rules'
export * from './validation'

export const stepsInfo = [
  {
    name: 'artist',
    title: 'Artist Details'
  },
  {
    name: 'project',
    title: 'Create Project'
  },
  {
    name: 'products',
    title: 'Add Products'
  },
  {
    name: 'confirmation',
    title: 'Confirmation'
  }
]

export const initialProductValue = {
  active: true,
  main: false,
  name: '',
  publish_date: '',
  configuration: 'single'
}

export const helperInfo = {
  addArtist: `Storybox connects an artist across multiple zones, so we need to ensure that we don’t create double entries. Artists share all artist-specific values like IDs and GPS statuses with all other Storybox zones.\r\n
Please check carefully if the artist exists in our database and select the respective artist when it appears in the search. If it does not, feel free to add the new artist. Once the artist has been added to GCDM, Storybox will link the profiles. Artists share all artist-specific values with all other Storybox zones. If this is not your artist, please clear the selected artist and do a new search or create a new artist.`,
  previewArtist: `Artists share all artist-specific values like IDs and GPS status with all other Storybox zones/labels.\r\n
If this is not your Artist, feel free to add a new artist to the system.`,
  createProject: `Choose a project name that reflects the content of the project, like the album name, Singles 2023, or the single’s name that you are working on.\r\n
Select the unit it belongs to and add information that can help people working on the project, for example, asset links from ISAAC, team information, and project information. This information can be edited later as well.\r\n 
A full URL is required for ISAAC links.`,
  customizeProject:
    'Your Team and Project information helps other teams find essential data (i.e., BM, coordinator, Promo KO, etc...) or a timeline that has been updated to suit the Storybox. You can edit this page, leave it as is, and press next to start reviewing stories.',
  createProduct: `To add a product, type in the product name and see if there is a matching result in the search. If there is, it will connect the product to GCDM and we will automatically display data like, charts, DSP playlists, and radio spins for that product.\r\n
If the product is not yet in the system, create a new product and we will search periodically for a potential match. You will be notified once a match is found, and you can verify if it is a match or not. Once we have a match, the charts, DSP playlists, and radio spin data will be shown.\r\n
Once you have added the product, you can click the three dots next to it and select if auto stories should be created with DSP playlist updates and radio spins updates. This feature can be turned on and off later as well.`
}
